import React from 'react';
import icons from '../../../../shared/utils/files/antIcons';
import getMess from '../translations';
import { ItemTypes } from '../../constants/constants';
const label = 'createNote';

const handler = (apiOptions, actions) => {
  const { getSelectedResources, rootContainer, controlConfiguration } = actions;

  const selectedResource = getSelectedResources()[0];

  const detail = {
    baseRequestParams: window?.ncFileManager,
    isMomentumEnabled: controlConfiguration.isMomentumEnabled,
    fileId: selectedResource.id,
  };

  const event = new CustomEvent('NCM_LAZY_LOAD_REACT_NEW_FILE_NOTE_MODAL', {
    detail: detail,
  });

  document.dispatchEvent(event);
};

export default (apiOptions, actions) => {
  const localeLabel = getMess(apiOptions.locale, label);
  const { getSelectedResources } = actions;

  return {
    id: label,
    icon: { icon: icons.check },
    label: localeLabel,
    resources: getSelectedResources(),
    shouldBeAvailable: () => {
      const selectedResources = getSelectedResources();
      return (
        selectedResources.length === 1 && selectedResources.every((resource) => resource.capabilities.canEdit && resource.type === ItemTypes.File)
      );
    },
    availableInContexts: ['row', 'toolbar'],
    handler: () => handler(apiOptions, actions),
  };
};
